module.exports = __webpack_public_path__ + "site/img/50.72d8fd01.jpg";